module.exports = __webpack_public_path__ + "static/project_mobile-b1ab330b77e35eaf6c81d0a677836519.png";